import * as c from '../../../../../../constants.jsx';
import NewbornPanelsCardTemplate from '../../../../../../components/CockpitCards/NewbornPanelsCardTemplate.jsx';

export default function OtherNewbornCard() {

return(
<>

<NewbornPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/othernewborn`}

  panel_name = { "OTHER RARE DISORDERS" }
  panel_subtext = {"This panel is based on the Recommended Uniform Screening Panel (RUSP), a list of conditions selected by experts for newborn screening programs."}

/>

</> 
)}

